import React, { useState } from "react";
import { useMemo } from "react";
import { openModal } from "../../../../Library/ModalPopUp";


export default function MYPCF(props) {
  const listData = props.mypcf ? props.mypcf : [];
  const maxSKS = props.maxSKS ? props.maxSKS : 24;

  /*==DATATABELS CONFIG==*/
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });
  const [totalRemove, setTotalRemove] = useState(0);

  const ResultData = useMemo(() => {
    let computedData = listData;
    computedData.sort((a, b) =>
      a.detail.coursetitle > b.detail.coursetitle ? 1 : -1
    );
    var totalRemove = computedData.filter(prev => prev.action_type === "remove");
    setTotalRemove(Object.values(totalRemove).length);

    var objSubjectUniq = computedData.reduce((accumulator, currentValue) => {
      if (currentValue.detail && currentValue.detail.hasOwnProperty('not_billed') && currentValue.detail.not_billed === 0) {
        if (currentValue.action_type) {
          if (currentValue.action_type === "add") {
            const { course_id, detail: { course_credit } } = currentValue;
            if (!accumulator.hasOwnProperty(course_id)) {
              accumulator[course_id] = course_credit;
            } else if (accumulator[course_id] !== course_credit) {
              accumulator[course_id] += course_credit;
            }
          }
        } else {
          const { course_id, detail: { course_credit } } = currentValue;
          if (!accumulator.hasOwnProperty(course_id)) {
            accumulator[course_id] = course_credit;
          } else if (accumulator[course_id] !== course_credit) {
            accumulator[course_id] += course_credit;
          }
        }
      }
      return accumulator;
    }, {});
    var tsks = 0;
    if (objSubjectUniq) {
      Object.keys(objSubjectUniq).map((k) => {
        tsks = tsks + objSubjectUniq[k];
      });
    }
    //setTotalItems(computedData.length);
    props.setTotalSKS(tsks);
    return computedData;
  }, [listData, currentPage, search, sorting]);
  /*==END DATATABELS CONFIG==*/

  const handlerChangePCF = (values) => {
    var objclone = [...listData];
    if (values.origin) {
      var xx = objclone.map((item) => {
        if (item.course_id === values.course_id && item.section_id === values.section_id) {
          item.action_type = "remove";
          //item.detail.action_type = "asc.course.action.remove";
        }
        return item;
      });
      props.setMypcf(xx);
    } else {
      var xx = objclone.filter(prev => prev.course_id !== values.course_id);
      props.setMypcf(xx);

    }
  }

  const handlerRedoPCF = (values) => {
    var objclone = [...listData];
    var xx = objclone.map((item) => {
      if (item.section_id === values.section_id) {
        item.action_type = (item.detail.action_type) ? ((item.detail.action_type === "asc.course.action.add") ? "add" : "remove") : "add";
        item.detail.action_type = (item.detail.action_type) ? item.detail.action_type : "asc.course.action.add";
      }
      return item;
    });
    props.setMypcf(xx);
    openModal({ open: false });
  }

  const ListRemovePCF = () => {
    var removedCourse = [...listData];
    var objremove = removedCourse.filter(prev => prev.action_type === "remove");
    return (
      <div className="hist-pcf">
        {Object.values(objremove).length > 0 ? (
          objremove.map((v, index) => (
            <div className="border p-3 rounded mb-8 shadow" key={index}>
              <div className="d-flex justify-content-start align-items-start">
                <div className="my-course w-100 ">
                  <span className="font-weight-bolder mb-1">{v.detail.coursetitle}</span>
                  <div>
                    <span className="text-muted font-weight-bold">{v.detail.course_code}</span>
                  </div>
                </div>
                <div className='info-course mx-2 mx-xxl-5'>
                  <span className="font-weight-bolder d-block">
                    Credit
                    <span className="ml-2 text-dark font-weight-bold">{v.detail.course_credit}</span>
                  </span>
                  <span className="text-muted text-capitalize">{v.detail.course_type}</span>
                </div>
                <button
                  className="d-none btn btn-sm btn-icon btn-warning p-5" type="button" title={"Redo this subject"} onClick={() => handlerRedoPCF(v, index)} >
                  <i className="fas fa-redo"></i>
                </button>
              </div>
              <div className="cost_owner mt-5">
                <span className="font-weight-bolder d-block">{(v.detail.section_id) ? v.detail.section_id : "-"}</span>
                <span className="font-weight-bolder text-muted">Section ID</span>
              </div>
            </div>
          ))
        ) : <p className="text-danger">No record found</p>}
      </div>
    )
  }

  const openHistPCF = () => {
    openModal({ header: "List of removed course from your PCF Revision", message: <ListRemovePCF /> });
  }

  return (
    <div className="card card-custom card-stretch gutter-b">
      <div className="card-header align-items-center border-0 mt-4">
        <h3 className="card-title align-items-start flex-column">
          <span className="font-weight-bolder text-dark">My PCF Revision</span>
          <span className="text-muted mt-3 font-weight-bold font-size-sm">
            Please fill in the list of courses you will take
          </span>
        </h3>
      </div>

      <div className="card-body p-0">
        <div className="h-100 d-flex flex-column justify-content-between">
          <div className="table-responsive" style={{ maxHeight: "900px", overflowY: "auto" }}>
            <table className="table table-head-custom table-head-bg table-borderless table-vertical-center">
              <thead>
                <tr>
                  <th><span className="text-dark">COURSE ({ResultData.length})</span></th>
                </tr>
              </thead>
              <tbody>
                {ResultData.length > 0 ? (
                  ResultData.map((v, index) => (
                    (!v.action_type || v.action_type === "add") ? (
                      <tr key={index}>
                        <td>
                          <div className={"border p-3 rounded " + ((v.action_type === "add" && (!v.hasOwnProperty("origin") || v?.origin === false)) ? "bg-light" : "")}>
                            <div className="d-flex justify-content-start align-items-start">
                              <div className="my-course w-100 ">
                                <span className="font-weight-bolder mb-1">{v.detail.coursetitle}</span>
                                <div>
                                  <span className="text-muted font-weight-bold">{v.detail.course_code}</span>
                                </div>
                              </div>
                              <div className='info-course mr-8'>
                                <span className="font-weight-bolder d-block">
                                  Credit
                                  <span className="ml-2 text-dark font-weight-bold">{v.detail.course_credit}</span>
                                </span>
                              </div>
                              <button
                                className="btn btn-sm btn-icon btn-danger p-5" type="button" title="Remove to your PCF" onClick={() => handlerChangePCF(v)} >
                                <i className="fas fa-times"></i>
                              </button>
                            </div>
                            <div className="section mt-5">
                              <span className="font-weight-bolder d-block">{v?.detail?.section_id} / {v?.detail?.section_name || v?.detail?.coursetitle || "-"}</span>
                              <span className="font-weight-bolder text-muted">Section ID/Name</span>
                            </div>
                          </div>
                        </td>
                      </tr>
                    ) : ""
                  ))
                ) : (
                  <tr>
                    <td colSpan={2}>No record found</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <div className="mt-2 p-2">
            <div className="text-center">
              <span className="font-weight-bolder d-block">
                Total Credit {props.totalsks} SKS
              </span>
              {props.totalsks > maxSKS && (
                <span className="label label-lg label-light-danger label-inline">
                  You have exceeded the maximum SKS
                </span>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
